"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scaleLinear = void 0;
exports.scaleLinear = function (config) {
    var _a = __read(config.domain, 2), x1 = _a[0], x2 = _a[1];
    var _b = __read(config.range, 2), y1 = _b[0], y2 = _b[1];
    var dx = x1 - x2;
    var dy = y1 - y2;
    if (dx === 0) {
        return function () { return x1; };
    }
    var slope = dy / dx;
    var yintercept = y1 - slope * x1;
    return function (value) {
        return slope * value + yintercept;
    };
};
//# sourceMappingURL=utils.js.map